import { render, staticRenderFns } from "./sale.vue?vue&type=template&id=6840f8d1"
import script from "./sale.vue?vue&type=script&lang=js"
export * from "./sale.vue?vue&type=script&lang=js"
import style0 from "./sale.vue?vue&type=style&index=0&id=6840f8d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports